import {createContext, useContext, useState} from 'react'

const VideoModalContext = createContext(null)

export function VideoModalProvider({ children }) {
  const [item, setItem] = useState(null)
  const contextValue = { item, setItem }

  return (
    <VideoModalContext value={contextValue}>
      {children}
    </VideoModalContext>
  )
}

export function useVideoModal() {
  return useContext(VideoModalContext)
}
